import React from "react";
import { AuthContextProvider } from "./contexts/auth";
import { TypesContextProvider } from "./contexts/types";
import AppRouter from "./AppRouter";
import "react-image-crop/dist/ReactCrop.css";

function App() {
  return (
    <AuthContextProvider>
      <TypesContextProvider>
        <div className="App">
          <AppRouter />
        </div>
      </TypesContextProvider>
    </AuthContextProvider>
  );
}

export default App;
